var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserContainer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 4.84615,
    fill: "url(#paint0_linear_50_35469)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2675 15.348V14.271C14.2675 13.6998 14.0405 13.152 13.6366 12.748C13.2327 12.3441 12.6849 12.1172 12.1136 12.1172H8.88285C8.31161 12.1172 7.76378 12.3441 7.35985 12.748C6.95593 13.152 6.729 13.6998 6.729 14.271V15.348",
    stroke: "white",
    strokeWidth: 1.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4986 9.96004C11.6881 9.96004 12.6524 8.99573 12.6524 7.80619C12.6524 6.61665 11.6881 5.65234 10.4986 5.65234C9.30904 5.65234 8.34473 6.61665 8.34473 7.80619C8.34473 8.99573 9.30904 9.96004 10.4986 9.96004Z",
    stroke: "white",
    strokeWidth: 1.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_35469",
    x1: 0,
    y1: 0,
    x2: 21,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A8AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserContainer);
export default __webpack_public_path__ + "static/media/userContainer.163a5b311052001f6b28708b4adf575e.svg";
export { ForwardRef as ReactComponent };